import { useEffect, useState } from 'react'
import {
  isDesktop as isDesktopDetect,
  isMobile as isMobileDetect,
} from 'react-device-detect'
import useDetectInstagramUA from '~/src/hooks/useDetectInstagramUA'

const useDeviceDetect = () => {
  const [loading, setLoading] = useState(true)
  const [isDesktop, setIsDesktop] = useState(isDesktopDetect)
  const [isMobile, setIsMobile] = useState(isMobileDetect)
  const { isInstagram, loading: isInstagramLoading } = useDetectInstagramUA()

  useEffect(() => {
    setIsDesktop(isDesktopDetect)
    setIsMobile(isMobileDetect)
    setLoading(false)

    return () => setLoading(false)
  }, [])

  return {
    isDesktop,
    isMobile,
    isInstagram,
    loading: loading || isInstagramLoading,
  }
}

export default useDeviceDetect
